const salesAnalyticsDonutChart = {
    series: [56, 38, 26],
    chartOptions: {
        chart: {
            type: 'donut',
            height: 240,
        },
        labels: ['Grupo 001', 'Grupo 002', 'Grupo 003'],
        colors: ['#556ee6', '#34c38f', '#f46a6a'],
        legend: {
            show: false,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                }
            }
        }
    }
};

const ChatData = [
    {
        id: 1,
        name: 'Limite de cliente',
        message: '0889955 - R$ 10.000,00',
        time: '10:40',
    },
    {
        id: 2,
        align: 'right',
        name: 'Meta atingida',
        message: 'Grupo Testes 001 - 450',
        time: '10:02'
    },
]

export { salesAnalyticsDonutChart, ChatData };
